try {
  class UpsellCheckbox extends HTMLElement {
    constructor() {
      super();
      this.CartDrawer = document.querySelector('cart-drawer');
      this.Cart = document.querySelector('cart-items');
      this.viewModel = this.getViewModel(this);
    }

    connectedCallback() {
      console.log(this.viewModel)
      this.viewModel.$addUpsellButton.addEventListener('click', this.handleAddToCart.bind(this));
    }

    handleAddToCart(event) {
      event.preventDefault();

      this.viewModel.$checkbox.classList.add('active');
      this.addToCart();
    }

    addToCart() {
        const { $section, $checkbox } = this.viewModel;
        $checkbox.classList.add('active');
        $section.classList.add('loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
              'items': [{
                'id': $section.getAttribute('data-variant-id'),
                'quantity': 1
              }],
              sections: this.CartDrawer.getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname
          }),
        })
          .then(response => response.json())
          .then(data => {
              $section.classList.add('hidden');
              this.CartDrawer.renderContents(data);
              this.Cart.onCartUpdate();
          })
          .catch(error => {
            console.error('Error adding item to cart:', error);
            this.enableAddToCart();
          })
          .finally(() => {
              $section.classList.remove('loading');

              // Move handling in cart-drawer.js and remove here and in product-form.js
              if (this.CartDrawer && this.CartDrawer.classList.contains('is-empty')) this.CartDrawer.classList.remove('is-empty');
          });
    }

    getViewModel(scope) {
        return {
            $section: scope,
            $checkbox: scope.querySelector('.cart-upsell-checkbox'),
            $addUpsellButton: scope.querySelector('.cart-upsell-button'),
        };
    }
  }

  customElements.define('upsell-checkbox', UpsellCheckbox);
} catch (e) {
  console.error("Error in UpsellCheckbox class:", e)
}
